/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ModalErrorDocumentoIntes.css';

class ModalErrorDocumentoIntes extends React.Component {
  componentDidMount() {}
  render() {
    return (
      <div className="modal fade" id="ModalErrorDocumentoIntes">
        <div className="modal-dialog">
          <div className={`${s.modalContent} modal-content`}>
            <div className="modal-header">
              <h5 className="modal-title">Actualización de datos</h5>
            </div>
            <div className={`${s.modalBody} modal-body`}>
              <div>
                Los datos de uno de los integrantes de tu grupo familiar están
                desactualizados y no podrá visualizar la información
                correspondiente. Por favor comunicate al  <strong>0810-444-7700</strong> para
                actualizar la información.
              </div>
            </div>
            <div className={`${s.modalFooter} modal-footer`}>
              <button
                data-dismiss="modal"
                className={`${s.boton_rojo} btn btn-danger text-center`}
              >
                Aceptar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, null)(withStyles(s)(ModalErrorDocumentoIntes));



// WEBPACK FOOTER //
// ./src/components/Telemedicina/ModalErrorDocumentoIntes/ModalErrorDocumentoIntes.js